import axios from "@/axios";
import { AxiosResponse } from "axios";
import qs from "qs";

import {
  AdDataResponse,
  OverallTrendsResponse,
  DemandSalesResponse,
  CPMTransitionResponse,
  ClientsResponse,
  AuctionTimeResponse,
  LatestDataDateResponse,
} from "@/features/home/types";

export function getClients(): Promise<AxiosResponse<ClientsResponse>> {
  return axios.get<ClientsResponse>(`/clients/`);
}

export function getAdData(
  period: number,
  reportType: number,
  publisher: number[],
  client: number[],
  startDate: string,
  endDate: string,
  language: string,
): Promise<AxiosResponse<AdDataResponse>> {
  return axios.get<AdDataResponse>(`/summary/ad-data/`, {
    params: {
      period: period,
      reportType: reportType,
      publisher: publisher,
      client: client,
      from: startDate !== "" ? startDate : undefined,
      to: endDate !== "" ? endDate : undefined,
      hl: language,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function getOverallTrends(
  period: number,
  reportType: number,
  publisher: number[],
  client: number[],
  startDate: string,
  endDate: string,
  language: string,
): Promise<AxiosResponse<OverallTrendsResponse>> {
  return axios.get<OverallTrendsResponse>(`/summary/overall-trends/`, {
    params: {
      period: period,
      reportType: reportType,
      publisher: publisher,
      client: client,
      from: startDate !== "" ? startDate : undefined,
      to: endDate !== "" ? endDate : undefined,
      hl: language,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function getDemandSales(
  period: number,
  reportType: number,
  publisher: number[],
  client: number[],
  startDate: string,
  endDate: string,
  language: string,
): Promise<AxiosResponse<DemandSalesResponse>> {
  return axios.get<DemandSalesResponse>(`/summary/demand-sales/`, {
    params: {
      period: period,
      reportType: reportType,
      publisher: publisher,
      client: client,
      from: startDate !== "" ? startDate : undefined,
      to: endDate !== "" ? endDate : undefined,
      hl: language,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function getCPMTransition(
  period: number,
  reportType: number,
  publisher: number[],
  client: number[],
  startDate: string,
  endDate: string,
  language: string,
): Promise<AxiosResponse<CPMTransitionResponse>> {
  return axios.get<CPMTransitionResponse>(`/summary/cpm-transitions/`, {
    params: {
      period: period,
      reportType: reportType,
      publisher: publisher,
      client: client,
      from: startDate !== "" ? startDate : undefined,
      to: endDate !== "" ? endDate : undefined,
      hl: language,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function getAuctionTime(
  period: number,
  publisher: number[],
  client: number[],
  startDate: string,
  endDate: string
): Promise<AxiosResponse<AuctionTimeResponse>> {
  return axios.get<AuctionTimeResponse>(`/summary/auction-time/`, {
    params: {
      period: period,
      publisher: publisher,
      client: client,
      from: startDate !== "" ? startDate : undefined,
      to: endDate !== "" ? endDate : undefined,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export function getLatestDataDate(): Promise<AxiosResponse<LatestDataDateResponse>> {
  return axios.get<LatestDataDateResponse>(`/summary/latest-data-date/`);
}
